import { BuilderContainerContext } from "components/builder/BuilderContainerContext";
import React from "react";
import BehaviorAutoCloseDelay from "./autoCloseDelay";
import BehaviorTrigger from "./trigger";
import BehaviorUrlTargeting from "./urlTargeting";

function LightboxBuilderBehaviorEdit() {
  const { builder } = React.useContext(BuilderContainerContext);
  const {
    drawer: { data: drawerData },
  } = builder;

  const EditComponent = {
    trigger: BehaviorTrigger,
    urlTargeting: BehaviorUrlTargeting,
    autoCloseDelay: BehaviorAutoCloseDelay,
  }[drawerData?.type];

  return EditComponent && <EditComponent />;
}

export default React.memo(LightboxBuilderBehaviorEdit);
